import DataFetcherTemplate from "../../hooks/fetchTemplate";
import DataDisplayOtrasFormas from "../../components/DataDisplayOtrasFormas";
function Ejemplo(){


    return(  <div className="margin">
        <DataFetcherTemplate url="https://tec.utpl.edu.ec/otras_formas_home">
          {(data) => <DataDisplayOtrasFormas data={data} />}
        </DataFetcherTemplate>
      </div> )
}

export default Ejemplo;